import qs from 'query-string'

export default (parameters) => qs.stringify(parameters, {
  skipNull: true,
  arrayFormat: 'comma',
})
